import type { PartnerRoles } from '@bridebook/web/lib/weddings/types';

/**
 * A partner's role in the wedding, as the record stores it. Mirrors the roles the app
 * defines for the settings page; that definition pulls in client-side code, and the
 * planner's server side reads this one.
 */
export const PARTNER_ROLES = ['bride', 'groom', 'other'] as const;

export type PartnerRole = (typeof PARTNER_ROLES)[number];

// Both lists must hold the same roles: a role added to one without the other fails here.
void (null as unknown as `${PartnerRoles}` satisfies PartnerRole);
void (null as unknown as PartnerRole satisfies `${PartnerRoles}`);

// A role slot as the record holds it: a role, or '' for none.
export type StoredPartnerRole = PartnerRole | '';

export const isPartnerRole = (value: unknown): value is PartnerRole =>
  PARTNER_ROLES.some((role) => role === value);

// A pair of roles as the cards show it, a dash for a slot with none.
export const describeRoles = (roles: readonly string[]): string =>
  roles.map((role) => role || '—').join(' & ');
